module.exports = __webpack_public_path__ + "img/down_ios_online.937ba03e.png";